// extracted by mini-css-extract-plugin
export default {"searchSection":"sidebar_searchSection__qqFYM","servicesBlock":"sidebar_servicesBlock__HKm01","sidebar":"sidebar_sidebar__dO+r2"};